import EllipsisToolTip from "../../../../../../base/basicComponents/ellipsisToolTip";
import BaseTbody from "../../../../../commonComponents/fileTbodys/baseFileTbody";
import { PreviewFileLink } from "app/pages/previewFile";
export default class ProcedureFileModalTbody extends BaseTbody {
  returnFileName = (rowColumn: any, column: any, row: any) => {
    return (
      <div className="fileNameContainer">
        <EllipsisToolTip
          children={
            <PreviewFileLink
              fileId={row.data.find((i: any) => i.name === "fileId").value}
              fileName={rowColumn.value}
            >
              {rowColumn.value}
            </PreviewFileLink>
          }
          title={rowColumn.value}
          placement="top"
          getPopupContainer={() => document.getElementsByClassName("procedureModalFiles")[0]}
        />
      </div>
    );
  };
}
